module.exports = __webpack_public_path__ + "img/country-switcher-white-cart-icon.d5ccd340.svg";